// extracted by mini-css-extract-plugin
export var badge = "DeploymentCards-module--badge--e6372";
export var badgeHighlighted = "DeploymentCards-module--badgeHighlighted--a3f5c";
export var card = "DeploymentCards-module--card--6abd8";
export var cardHighlighted = "DeploymentCards-module--cardHighlighted--ed91f";
export var description = "DeploymentCards-module--description--34a6a";
export var grid = "DeploymentCards-module--grid--b16da";
export var heading = "DeploymentCards-module--heading--15312";
export var link = "DeploymentCards-module--link--88d7a";